import { useEffect, useState } from 'react';
import { CultureSplitButton } from 'src/components/common/buttons/CultureSplitButton';
import { DEFAULT_CULTURE } from 'src/constants';
import { useProductVersions } from 'src/hooks/useProductVersions';
import { buildGalleryUrl } from 'src/util/galleryUrlBuilder';

type SetDefinition = Models.SetsPlayground.SetDefinition;

interface PreviewGalleryButtonProps {
    productKey: string;
    cultures: string[];
    sets: SetDefinition[];
}

export const PreviewGalleryButton = ({
    productKey,
    cultures,
    sets,
}: PreviewGalleryButtonProps): JSX.Element => {
    const [selectedCulture, setSelectedCulture] = useState('');
    const { currentProductVersion } = useProductVersions(productKey);

    useEffect(() => {
        if (!cultures.includes(selectedCulture)) {
            setSelectedCulture(cultures.includes(DEFAULT_CULTURE) ? DEFAULT_CULTURE : cultures[0] ?? '');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cultures]);

    const isDisabled = sets.length === 0 || !selectedCulture || !currentProductVersion;

    const handlePreview = (): void => {
        const url = buildGalleryUrl(
            selectedCulture,
            productKey,
            currentProductVersion,
            undefined,
            sets,
        );

        window.open(url, '_blank');
    };

    return (
        <CultureSplitButton
            ariaLabel="Preview in Gallery Button"
            cultures={cultures}
            disabled={isDisabled}
            label="Preview in Gallery"
            selectedCulture={selectedCulture}
            tooltip={
                isDisabled
                    ? 'Add at least one culture and one set to the selected culture group to preview it in a gallery.'
                    : 'Preview the selected culture group\'s sets in a gallery.'
            }
            onClick={handlePreview}
            onSelectCulture={setSelectedCulture}
        />
    );
};
